export default __webpack_public_path__ + "static/media/close.85d259bb.svg";